/* eslint-disable @typescript-eslint/no-unused-vars */
import { MessageType } from '@doveit/bricks';
import { ActionColor } from '@doveit/bricks/dist/typings/components/action/types';
import {
  GoalMetric, IndividualGoal, ManagerGoal, PerformanceRating, TimeRange,
} from '../../../../providers/api/dtos';
import { getPerformanceTitle } from './getPerformanceTitle';
import { getPerformanceDescription } from './getPerformanceDescription';
import { getTargetDescription } from './getTargetDescription';
import { getPerformanceMessage } from './getPerformanceMessage';
import { getPerformanceAction, PerformanceActionType } from './getPerformanceAction';

export type PerformanceDetailsConfig = {
  title: string,
  status: PerformanceRating,
  progress: number,
  performanceDescription: string,
  targetDescription?: string,
  message: {
    title: string,
    // todo: make it required when we introduce the learning platform
    description?: string,
    type: MessageType,
  },
  action?: {
    label: string,
    color: ActionColor,
    type: PerformanceActionType,
  }
};

export function getPerformanceDetails(
  metric: GoalMetric,
  goal: ManagerGoal,
  timeRange: TimeRange,
): PerformanceDetailsConfig {
  const { target, metrics } = goal;
  const metricData = metrics[metric];

  return {
    title: getPerformanceTitle({
      metric,
      metricData,
    }),
    status: metricData.yearly.status,
    progress: metricData.yearly.progress,
    performanceDescription: getPerformanceDescription({
      metric,
      metricData,
      timeRange,
    }),
    targetDescription: getTargetDescription({
      metric,
      metricData,
      salesProgress: metrics.sales.yearly.progress,
      timeRange,
    }),
    message: getPerformanceMessage({
      target: target.manager,
      metric,
      metricData,
      salesMetric: metrics.sales,
    }),
    action: getPerformanceAction(metric, metrics),
  };
}
